/*! @preserve
 * numeral.js
 * version : 1.5.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function () {
	function a(a) {
		this._value = a;
	}
	function b(a, b, c, d) {
		var e,
			f,
			g,
			h,
			i = a.toString().split('.'),
			j = b - (d || 0);
		return (
			(e = 2 === i.length ? Math.min(Math.max(i[1].length, j), b) : j),
			(g = Math.pow(10, e)),
			(h = (c(a * g) / g).toFixed(e)),
			d > b - e && ((f = new RegExp('\\.?0{1,' + (d - (b - e)) + '}$')), (h = h.replace(f, ''))),
			h
		);
	}
	function c(a, b, c) {
		var j;
		return (j =
			0 === a._value && null !== s.zeroFormat
				? s.zeroFormat
				: null === a._value && null !== s.nullFormat
				? s.nullFormat
				: b.indexOf('$') > -1
				? d(a, b, c)
				: b.indexOf('%') > -1
				? e(a, b, c)
				: b.indexOf(':') > -1
				? h(a, b)
				: b.indexOf('b') > -1 || b.indexOf('ib') > -1
				? f(a, b, c)
				: b.indexOf('o') > -1
				? g(a, b, c)
				: i(a._value, b, c));
	}
	function d(a, b, c) {
		var d,
			e,
			f = b.indexOf('$'),
			g = b.indexOf('('),
			h = b.indexOf('-'),
			j = '';
		return (
			b.indexOf(' $') > -1
				? ((j = ' '), (b = b.replace(' $', '')))
				: b.indexOf('$ ') > -1
				? ((j = ' '), (b = b.replace('$ ', '')))
				: (b = b.replace('$', '')),
			(e = i(a._value, b, c, !1)),
			1 >= f
				? e.indexOf('(') > -1 || e.indexOf('-') > -1
					? ((e = e.split('')),
					  (d = 1),
					  (g > f || h > f) && (d = 0),
					  e.splice(d, 0, q[s.currentLanguage].currency.symbol + j),
					  (e = e.join('')))
					: (e = q[s.currentLanguage].currency.symbol + j + e)
				: e.indexOf(')') > -1
				? ((e = e.split('')),
				  e.splice(-1, 0, j + q[s.currentLanguage].currency.symbol),
				  (e = e.join('')))
				: (e = e + j + q[s.currentLanguage].currency.symbol),
			e
		);
	}
	function e(a, b, c) {
		var d,
			e = '',
			f = 100 * a._value;
		return (
			b.indexOf(' %') > -1 ? ((e = ' '), (b = b.replace(' %', ''))) : (b = b.replace('%', '')),
			(d = i(f, b, c)),
			d.indexOf(')') > -1
				? ((d = d.split('')), d.splice(-1, 0, e + '%'), (d = d.join('')))
				: (d = d + e + '%'),
			d
		);
	}
	function f(a, b, c) {
		var d,
			e,
			f,
			g,
			h = b.indexOf('ib') > -1 ? t.iec : t.bytes,
			j = a._value,
			k = '';
		for (
			b.indexOf(' b') > -1 || b.indexOf(' ib') > -1
				? ((k = ' '), (b = b.replace(' ib', '').replace(' b', '')))
				: (b = b.replace('ib', '').replace('b', '')),
				e = 0;
			e <= h.length;
			e++
		)
			if (
				((f = Math.pow(1024, e)),
				(g = Math.pow(1024, e + 1)),
				null === j || 0 === j || (j >= f && g > j))
			) {
				(k += h[e]), f > 0 && (j /= f);
				break;
			}
		return (d = i(j, b, c)), d + k;
	}
	function g(a, b, c) {
		var d,
			e = '';
		return (
			b.indexOf(' o') > -1 ? ((e = ' '), (b = b.replace(' o', ''))) : (b = b.replace('o', '')),
			(e += q[s.currentLanguage].ordinal(a._value)),
			(d = i(a._value, b, c)),
			d + e
		);
	}
	function h(a) {
		var b = Math.floor(a._value / 60 / 60),
			c = Math.floor((a._value - 60 * b * 60) / 60),
			d = Math.round(a._value - 60 * b * 60 - 60 * c);
		return b + ':' + (10 > c ? '0' + c : c) + ':' + (10 > d ? '0' + d : d);
	}
	function i(a, c, d) {
		var e,
			f,
			g,
			h,
			i = !1,
			j = !1,
			k = !1,
			l = '',
			m = !1,
			n = !1,
			o = !1,
			p = !1,
			r = !1,
			t = '',
			u = !1;
		return (
			null === a && (a = 0),
			(e = Math.abs(a)),
			c.indexOf('(') > -1
				? ((i = !0), (c = c.slice(1, -1)))
				: c.indexOf('+') > -1 && ((j = !0), (c = c.replace(/\+/g, ''))),
			c.indexOf('a') > -1 &&
				((m = c.indexOf('aK') >= 0),
				(n = c.indexOf('aM') >= 0),
				(o = c.indexOf('aB') >= 0),
				(p = c.indexOf('aT') >= 0),
				(r = m || n || o || p),
				c.indexOf(' a') > -1 && (l = ' '),
				(c = c.replace(new RegExp(l + 'a[KMBT]?'), '')),
				(e >= Math.pow(10, 12) && !r) || p
					? ((l += q[s.currentLanguage].abbreviations.trillion), (a /= Math.pow(10, 12)))
					: (e < Math.pow(10, 12) && e >= Math.pow(10, 9) && !r) || o
					? ((l += q[s.currentLanguage].abbreviations.billion), (a /= Math.pow(10, 9)))
					: (e < Math.pow(10, 9) && e >= Math.pow(10, 6) && !r) || n
					? ((l += q[s.currentLanguage].abbreviations.million), (a /= Math.pow(10, 6)))
					: ((e < Math.pow(10, 6) && e >= Math.pow(10, 3) && !r) || m) &&
					  ((l += q[s.currentLanguage].abbreviations.thousand), (a /= Math.pow(10, 3)))),
			c.indexOf('[.]') > -1 && ((k = !0), (c = c.replace('[.]', '.'))),
			(f = a.toString().split('.')[0]),
			(g = c.split('.')[1]),
			(h = c.indexOf(',')),
			g
				? (g.indexOf('[') > -1
						? ((g = g.replace(']', '')),
						  (g = g.split('[')),
						  (t = b(a, g[0].length + g[1].length, d, g[1].length)))
						: (t = b(a, g.length, d)),
				  (f = t.split('.')[0]),
				  (t =
						t.indexOf('.') > -1 ? q[s.currentLanguage].delimiters.decimal + t.split('.')[1] : ''),
				  k && 0 === Number(t.slice(1)) && (t = ''))
				: (f = b(a, null, d)),
			f.indexOf('-') > -1 && ((f = f.slice(1)), (u = !0)),
			h > -1 &&
				(f = f
					.toString()
					.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + q[s.currentLanguage].delimiters.thousands)),
			0 === c.indexOf('.') && (f = ''),
			(i && u ? '(' : '') +
				(!i && u ? '-' : '') +
				(!u && j ? '+' : '') +
				f +
				t +
				(l ? l : '') +
				(i && u ? ')' : '')
		);
	}
	function j(a, b) {
		var c,
			d,
			e,
			f,
			g,
			h,
			i = b,
			j = !1;
		if (b.indexOf(':') > -1) h = k(b);
		else if (b === s.zeroFormat || b === s.nullFormat) h = 0;
		else {
			for (
				'.' !== q[s.currentLanguage].delimiters.decimal &&
					(b = b.replace(/\./g, '').replace(q[s.currentLanguage].delimiters.decimal, '.')),
					c = new RegExp(
						'[^a-zA-Z]' +
							q[s.currentLanguage].abbreviations.thousand +
							'(?:\\)|(\\' +
							q[s.currentLanguage].currency.symbol +
							')?(?:\\))?)?$'
					),
					d = new RegExp(
						'[^a-zA-Z]' +
							q[s.currentLanguage].abbreviations.million +
							'(?:\\)|(\\' +
							q[s.currentLanguage].currency.symbol +
							')?(?:\\))?)?$'
					),
					e = new RegExp(
						'[^a-zA-Z]' +
							q[s.currentLanguage].abbreviations.billion +
							'(?:\\)|(\\' +
							q[s.currentLanguage].currency.symbol +
							')?(?:\\))?)?$'
					),
					f = new RegExp(
						'[^a-zA-Z]' +
							q[s.currentLanguage].abbreviations.trillion +
							'(?:\\)|(\\' +
							q[s.currentLanguage].currency.symbol +
							')?(?:\\))?)?$'
					),
					g = 1;
				g <= t.bytes.length &&
				!(j = b.indexOf(t.bytes[g]) > -1 || b.indexOf(t.iec[g]) > -1 ? Math.pow(1024, g) : !1);
				g++
			);
			(h = j ? j : 1),
				(h *= i.match(c) ? Math.pow(10, 3) : 1),
				(h *= i.match(d) ? Math.pow(10, 6) : 1),
				(h *= i.match(e) ? Math.pow(10, 9) : 1),
				(h *= i.match(f) ? Math.pow(10, 12) : 1),
				(h *= b.indexOf('%') > -1 ? 0.01 : 1),
				(h *=
					(b.split('-').length + Math.min(b.split('(').length - 1, b.split(')').length - 1)) % 2
						? 1
						: -1),
				(h *= Number(b.replace(/[^0-9\.]+/g, ''))),
				(h = j ? Math.ceil(h) : h);
		}
		return (a._value = h), a._value;
	}
	function k(a) {
		var b = a.split(':'),
			c = 0;
		return (
			3 === b.length
				? ((c += 60 * Number(b[0]) * 60), (c += 60 * Number(b[1])), (c += Number(b[2])))
				: 2 === b.length && ((c += 60 * Number(b[0])), (c += Number(b[1]))),
			Number(c)
		);
	}
	function l(a, b) {
		q[a] = b;
	}
	function m(a) {
		var b = a.toString().split('.');
		return b.length < 2 ? 1 : Math.pow(10, b[1].length);
	}
	function n() {
		var a = Array.prototype.slice.call(arguments);
		return a.reduce(function (a, b) {
			var c = m(a),
				d = m(b);
			return c > d ? c : d;
		}, -(1 / 0));
	}
	var o,
		p = '1.5.5',
		q = {},
		r = { currentLanguage: 'en', zeroFormat: null, nullFormat: null, defaultFormat: '0,0' },
		s = {
			currentLanguage: r.currentLanguage,
			zeroFormat: r.zeroFormat,
			nullFormat: r.nullFormat,
			defaultFormat: r.defaultFormat
		},
		t = {
			bytes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			iec: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
		};
	(o = function (b) {
		return (
			(b = o.isNumeral(b)
				? b.value()
				: 0 === b || 'undefined' == typeof b
				? 0
				: null === b
				? null
				: Number(b)
				? Number(b)
				: o.fn.unformat(b)),
			new a(b)
		);
	}),
		(o.version = p),
		(o.isNumeral = function (b) {
			return b instanceof a;
		}),
		(o.language = function (a, b) {
			if (!a) return s.currentLanguage;
			if (((a = a.toLowerCase()), a && !b)) {
				if (!q[a]) throw new Error('Unknown language : ' + a);
				s.currentLanguage = a;
			}
			return (b || !q[a]) && l(a, b), o;
		}),
		(o.reset = function () {
			for (var a in r) s[a] = r[a];
		}),
		(o.languageData = function (a) {
			if (!a) return q[s.currentLanguage];
			if (!q[a]) throw new Error('Unknown language : ' + a);
			return q[a];
		}),
		o.language('en', {
			delimiters: { thousands: ',', decimal: '.' },
			abbreviations: { thousand: 'k', million: 'm', billion: 'b', trillion: 't' },
			ordinal: function (a) {
				var b = a % 10;
				return 1 === ~~((a % 100) / 10)
					? 'th'
					: 1 === b
					? 'st'
					: 2 === b
					? 'nd'
					: 3 === b
					? 'rd'
					: 'th';
			},
			currency: { symbol: '$' }
		}),
		(o.zeroFormat = function (a) {
			s.zeroFormat = 'string' == typeof a ? a : null;
		}),
		(o.nullFormat = function (a) {
			s.nullFormat = 'string' == typeof a ? a : null;
		}),
		(o.defaultFormat = function (a) {
			s.defaultFormat = 'string' == typeof a ? a : '0.0';
		}),
		(o.validate = function (a, b) {
			var c, d, e, f, g, h, i, j;
			if (
				('string' != typeof a &&
					((a += ''),
					console.warn &&
						console.warn('Numeral.js: Value is not string. It has been co-erced to: ', a)),
				(a = a.trim()),
				a.match(/^\d+$/))
			)
				return !0;
			if ('' === a) return !1;
			try {
				i = o.languageData(b);
			} catch (k) {
				i = o.languageData(o.language());
			}
			return (
				(e = i.currency.symbol),
				(g = i.abbreviations),
				(c = i.delimiters.decimal),
				(d = '.' === i.delimiters.thousands ? '\\.' : i.delimiters.thousands),
				(j = a.match(/^[^\d]+/)),
				null !== j && ((a = a.substr(1)), j[0] !== e)
					? !1
					: ((j = a.match(/[^\d]+$/)),
					  null !== j &&
					  ((a = a.slice(0, -1)),
					  j[0] !== g.thousand && j[0] !== g.million && j[0] !== g.billion && j[0] !== g.trillion)
							? !1
							: ((h = new RegExp(d + '{2}')),
							  a.match(/[^\d.,]/g)
									? !1
									: ((f = a.split(c)),
									  f.length > 2
											? !1
											: f.length < 2
											? !!f[0].match(/^\d+.*\d$/) && !f[0].match(h)
											: 1 === f[0].length
											? !!f[0].match(/^\d+$/) && !f[0].match(h) && !!f[1].match(/^\d+$/)
											: !!f[0].match(/^\d+.*\d$/) && !f[0].match(h) && !!f[1].match(/^\d+$/))))
			);
		}),
		Array.prototype.reduce ||
			(Array.prototype.reduce = function (a) {
				'use strict';
				if (null === this)
					throw new TypeError('Array.prototype.reduce called on null or undefined');
				if ('function' != typeof a) throw new TypeError(a + ' is not a function');
				var b,
					c = Object(this),
					d = c.length >>> 0,
					e = 0;
				if (2 === arguments.length) b = arguments[1];
				else {
					for (; d > e && !(e in c); ) e++;
					if (e >= d) throw new TypeError('Reduce of empty array with no initial value');
					b = c[e++];
				}
				for (; d > e; e++) e in c && (b = a(b, c[e], e, c));
				return b;
			}),
		(o.fn = a.prototype = {
			clone: function () {
				return o(this);
			},
			format: function (a, b) {
				return c(this, a ? a : s.defaultFormat, void 0 !== b ? b : Math.round);
			},
			unformat: function (a) {
				return '[object Number]' === Object.prototype.toString.call(a)
					? a
					: j(this, a ? a : s.defaultFormat);
			},
			value: function () {
				return this._value;
			},
			valueOf: function () {
				return this._value;
			},
			set: function (a) {
				return (this._value = Number(a)), this;
			},
			add: function (a) {
				function b(a, b, d, e) {
					return a + c * b;
				}
				var c = n.call(null, this._value, a);
				return (this._value = [this._value, a].reduce(b, 0) / c), this;
			},
			subtract: function (a) {
				function b(a, b, d, e) {
					return a - c * b;
				}
				var c = n.call(null, this._value, a);
				return (this._value = [a].reduce(b, this._value * c) / c), this;
			},
			multiply: function (a) {
				function b(a, b, c, d) {
					var e = n(a, b);
					return (a * e * (b * e)) / (e * e);
				}
				return (this._value = [this._value, a].reduce(b, 1)), this;
			},
			divide: function (a) {
				function b(a, b, c, d) {
					var e = n(a, b);
					return (a * e) / (b * e);
				}
				return (this._value = [this._value, a].reduce(b)), this;
			},
			difference: function (a) {
				return Math.abs(o(this._value).subtract(a).value());
			}
		}),
		'undefined' != typeof module && module.exports && (module.exports = o),
		'undefined' == typeof ender && (this.numeral = o),
		'function' == typeof define &&
			define.amd &&
			define([], function () {
				return o;
			});
}.call(this));
